export default __webpack_public_path__ + "static/media/post2.11ffd05b.txt";